export default __webpack_public_path__ + "static/media/upselling.16f687c5.svg";